import { QSenseHubControlPlugin } from '@/plugins/QSenseHubControl';

import { IConnectionStrategy } from '../interfaces/IConnectionStrategy';
import { IFileTransferStrategy } from '../interfaces/IFileTransferStrategy';
import { IListenerRegistry } from '../interfaces/IListenerRegistry';
import { IScanStrategy } from '../interfaces/IScanStrategy';

export class HubScanStrategy implements IScanStrategy {
  async start() {
    return { status: 'noop' };
  }

  async stop() {
    return { status: 'noop' };
  }
}

export class HubFileTransferStrategy implements IFileTransferStrategy {
  constructor(
    private plugin: QSenseHubControlPlugin,
    private listeners: IListenerRegistry,
  ) {}

  async upload(callback: VoidFunction) {
    this.listeners.add('onFileSelected', callback, 'onFileSelected--upload');

    await this.plugin.openDocumentPicker();
  }

  async download(callback: VoidFunction) {
    this.listeners.add('onFileSelected', callback, 'onFileSelected--download');

    await this.plugin.readFile();
  }
}

export class HubConnectionStrategy implements IConnectionStrategy {
  constructor(
    private plugin: QSenseHubControlPlugin,
    private listeners: IListenerRegistry,
  ) {}

  async connect(callback: VoidFunction) {
    this.listeners.add('onHubConnected', callback);

    await this.plugin.connectHub();
  }

  async disconnect() {
    await this.plugin.DisconnectHub();
  }
}
